window.createVisibilityObserver = function createVisibilityObserver(
  targetClass,
  callback,
  threshold = 0.1
) {
  if (typeof callback !== 'function') {
    return;
  }

  if (typeof threshold !== 'number' || threshold < 0 || threshold > 1) {
    threshold = 0.1;
  }

  function onElementVisible(entry) {
    if (entry.isIntersecting) {
      callback(entry.target);
    }
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: threshold,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(onElementVisible);
  }, observerOptions);

  if (document.querySelector(`.${targetClass}`)) {
    document.querySelectorAll(`.${targetClass}`).forEach((el) => {
      observer.observe(el);
    });
  }
};

window.lineTitlesFunc = function lineTitlesFunc(titlesArr, options = {}) {
  const hasDynamicGroups = typeof options.getGroups === 'function';
  let resizeTimeout = null;
  let resizeFrame = null;
  let initTimeout = null;
  let isDestroyed = false;
  let loadListenerAdded = false;

  const toElementsArray = (items) => {
    if (!items) {
      return [];
    }

    return Array.from(items).filter((item) => {
      return item && item.style && typeof item.offsetHeight === 'number';
    });
  };

  const getLineTitlesGroups = () => {
    if (hasDynamicGroups) {
      const groups = options.getGroups();

      if (!groups) {
        return [];
      }

      return Array.from(groups)
        .map(toElementsArray)
        .filter((group) => group.length);
    }

    const elements = toElementsArray(titlesArr);

    return elements.length ? [elements] : [];
  };

  const resetLineTitlesHeight = (groups) => {
    const elements = [];

    groups.forEach((group) => {
      group.forEach((title) => {
        elements.push(title);
      });
    });

    Array.from(new Set(elements)).forEach((title) => {
      title.style.minHeight = '';
    });
  };

  const setLineTitlesHeight = () => {
    if (isDestroyed) {
      return;
    }

    const groups = getLineTitlesGroups();

    resetLineTitlesHeight(groups);

    groups.forEach((group) => {
      let maxHeight = 0;

      group.forEach((title) => {
        const height = title.offsetHeight;

        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      group.forEach((title) => {
        title.style.minHeight = maxHeight + 'px';
      });
    });
  };

  const requestLineTitlesHeight = () => {
    if (isDestroyed) {
      return;
    }

    if (resizeFrame) {
      cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = null;
      setLineTitlesHeight();
    });
  };

  const runLineTitlesHeight = () => {
    if (isDestroyed) {
      return;
    }

    if (initTimeout) {
      clearTimeout(initTimeout);
    }

    initTimeout = setTimeout(() => {
      initTimeout = null;
      requestLineTitlesHeight();
    }, 50);
  };

  const onLineTitlesResize = () => {
    if (isDestroyed) {
      return;
    }

    if (resizeTimeout) {
      return;
    }

    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      requestLineTitlesHeight();
    }, 150);
  };

  runLineTitlesHeight();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(runLineTitlesHeight).catch(runLineTitlesHeight);
  } else {
    loadListenerAdded = true;
    window.addEventListener('load', runLineTitlesHeight, { once: true });
  }

  window.addEventListener('resize', onLineTitlesResize, { passive: true });

  return {
    refresh: requestLineTitlesHeight,
    destroy: () => {
      const groups = getLineTitlesGroups();

      isDestroyed = true;

      if (initTimeout) {
        clearTimeout(initTimeout);
        initTimeout = null;
      }

      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
        resizeTimeout = null;
      }

      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = null;
      }

      if (loadListenerAdded) {
        window.removeEventListener('load', runLineTitlesHeight);
      }

      window.removeEventListener('resize', onLineTitlesResize);
      resetLineTitlesHeight(groups);
    },
  };
};
